/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { css } from '@emotion/react';
import { TextFieldStyled, DropDownStyled, IconButton } from '@nike/nike-design-system-components';
import { Close, Search } from '@nike/nike-design-system-icons';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const statusSearchStyles = css`
  display: flex;
  align-items: center;
  fieldset {
    border-radius: 0;
    height: 45px;
    border-color: #e5e5e5;
  }
  .status-search-v2-input,
  .status-search-v2-key-dropdown,
  .status-search-v2-search-button {
    min-height: 45px;
    .nds-input-label:not(.active) {
      font-size: 12px;
      top: 10px;
    }
  }
  .status-search-v2-input > .nds-input-layout-control,
  .status-search-v2-key-dropdown > .nds-select-layout-control {
    height: 45px;

    label {
      font-size: 14px;
      top: 8px;
    }

    input {
      font-size: 14px;
    }
  }
  .status-search-v2-key-dropdown .value-display > span {
    font-size: 14px;
  }
  .status-search-v2-search-button {
    border-radius: 0;
    border: 1px solid #e5e5e5;
    background-color: white;
    height: 45px;
    top: 2px;
    svg {
      color: black;
    }
    &:hover {
      background-color: white;
      border: 1px solid black;
    }
  }
`;

const StatusSearch = ({ name, setSearchValues, searchKeyOptions, clearSearch }) => (
  <Formik
    initialValues={{ searchKey: searchKeyOptions[0].value }}
    onSubmit={values => setSearchValues(values)}
    render={({ values, handleSubmit, handleChange, setFieldValue }) => (
      <form onSubmit={handleSubmit}>
        <div css={statusSearchStyles}>
          <TextFieldStyled
            label={new TranslatedCopy({ id: 'global.search' }).toString()}
            name='searchTerm'
            value={values.searchTerm}
            onChange={handleChange}
            TrailingIcon={<Close />}
            onIconClick={() => {
              setFieldValue('searchTerm', '');
              clearSearch();
            }}
            className='status-search-v2-input'
            inputProps={{ style: { height: '45px' } }}
            minLength={3}
          />
          <DropDownStyled
            label={new TranslatedCopy({ id: 'global.search' }).toString()}
            id={`${name}__searchKey`}
            name='searchKey'
            value={values.searchKey}
            options={searchKeyOptions}
            onChange={handleChange}
            className='status-search-v2-key-dropdown'
          />
          <div>
            <IconButton
              type='submit'
              appearance='secondary'
              ariaLabel={`${name}__button_search`}
              Icon={<Search />}
              onClick={handleSubmit}
              className='status-search-v2-search-button'
              style={{ backgroundColor: 'transparent', outline: 'none' }}
            />
          </div>
        </div>
      </form>
    )}
  />
);

StatusSearch.propTypes = {
  name: PropTypes.string.isRequired,
  setSearchValues: PropTypes.func.isRequired,
  searchKeyOptions: PropTypes.array.isRequired,
  clearSearch: PropTypes.func.isRequired
};

export default StatusSearch;
